import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-background-class',
  templateUrl: './background-class.component.html',
  styleUrls: ['./background-class.component.scss']
})
export class BackgroundClassComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
